export const name = 'externalComponent' as const

export const ExternalComponentAPISymbol = Symbol('ExternalComponentAPI')
